<div class="buttons-wrapper">
  <ng-content></ng-content>
</div>
